import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useShopInsuranceModalQueryParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [queryParam, setQueryParam] = useState<any>(null);
  const [openShopInsuranceModal, setOpenShopInsuranceModal] = useState(false);
  const [shopInsuranceParam, setShopInsuranceParam] = useState(false);
  const [isQueryReady, setIsQueryReady] = useState(false);
  const [suggestDownloadReportParam, setSuggestDownloadReportParam] = useState(false);

  useEffect(() => {
    const paymentOption = searchParams.get('paymentOption');
    const buyerOption = searchParams.get('buyerOption');
    const selectTabOption = searchParams.get('selectTabOption');
    const shopInsuranceOption = searchParams.get('shopInsurance');
    const downloadReportParam = searchParams.get('downloadReport');

    if (
      paymentOption ||
      buyerOption ||
      selectTabOption ||
      (shopInsuranceOption === 'true' && !openShopInsuranceModal)
    ) {
      const parsedParams = {
        paymentOption: paymentOption?.replace('_', ' '),
        buyerOption,
        selectTabOption,
        shopInsuranceOption,
      };
      setShopInsuranceParam(shopInsuranceOption === 'true');
      setQueryParam(parsedParams);
      setOpenShopInsuranceModal(true);
    }

    if (downloadReportParam === 'true' && !suggestDownloadReportParam) {
      setSuggestDownloadReportParam(true);
    }

    setIsQueryReady(true);
  }, [searchParams]);

  const handleOpenShopInsuranceModal = useCallback(() => {
    setOpenShopInsuranceModal(true);
    if (!shopInsuranceParam) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('shopInsurance', 'true');
      setSearchParams(newParams, { replace: true });
    }
  }, [shopInsuranceParam, searchParams, setSearchParams]);

  const handleCloseShopInsuranceModal = useCallback(
    (extraParams?: Record<string, string>) => {
      setOpenShopInsuranceModal(false);
      const newParams = new URLSearchParams(searchParams);
      if (shopInsuranceParam) {
        newParams.delete('shopInsurance');
      }
      newParams.delete('paymentOption');
      newParams.delete('buyerOption');
      newParams.delete('selectTabOption');

      if (extraParams) {
        Object.entries(extraParams).forEach(([key, value]) => {
          newParams.set(key, value);
        });
      }
      setSearchParams(newParams, { replace: true });
    },
    [shopInsuranceParam, searchParams, setSearchParams],
  );

  const handleShowDownloadReport = useCallback(() => {
    setSuggestDownloadReportParam(true);
  }, []);

  return {
    queryParam,
    openShopInsuranceModal,
    setOpenShopInsuranceModal,
    isQueryReady,
    suggestDownloadReportParam,
    handleOpenShopInsuranceModal,
    handleCloseShopInsuranceModal,
    handleShowDownloadReport,
  };
}
